import {IModalServiceInstance} from 'angular-ui-bootstrap';
import {
    begruendungsCodeLongPostfix,
    begruendungsCodePrefix,
    begruendungsCodeShortPostfix,
    getTSBegruendungsCode,
    TSBegruendungsCode
} from '../../models/enums/TSBegruendungsCode';
import ITranslateService = angular.translate.ITranslateService;

let style = require('./bemerkungDialog.scss');

export class BemerkungDialogController {

    static $inject = ['$uibModalInstance', '$translate', 'text', 'begrundungscodeOptions', 'showBegruendung', 'showBemerkung'];

    bemerkung: string;
    begruendung: TSBegruendungsCode;
    text: string;
    begruendungscodeOptions: TSBegruendungsCode[];

    constructor(private $uibModalInstance: IModalServiceInstance, private $translate: ITranslateService, text: string,
                begrundungscodeOptions: TSBegruendungsCode[], private showBegruendung: boolean, private showBemerkung: boolean) {
        if (text !== undefined && text !== null) {
            this.text = $translate.instant(text);
        } else {
            this.text = 'test';
        }

        if (begrundungscodeOptions === undefined) {
            this.begruendungscodeOptions = getTSBegruendungsCode();
        } else {
            this.begruendungscodeOptions = begrundungscodeOptions
        }

    }

    ok(): void {
        //this.$uibModalInstance.close({lat: this.lat, lon: this.lon});
        this.$uibModalInstance.close({begruendung: this.begruendung, bemerkung: this.bemerkung});
    };

    cancel(): void {
        this.$uibModalInstance.dismiss('cancel');
    };

    writeLongTranslationToBemerkung() {
        this.bemerkung = this.getLongTranslationFroCode(this.begruendung);

    }

    getLongTranslationFroCode(code: TSBegruendungsCode): string {

        let translationKey: string = begruendungsCodePrefix() + code + begruendungsCodeLongPostfix();
        return this.$translate.instant(translationKey)

    }

    getTranslationForCode(code: TSBegruendungsCode): string {

        let translationKey: string = begruendungsCodePrefix() + code + begruendungsCodeShortPostfix();
        return this.$translate.instant(translationKey)

    }

}



// WEBPACK FOOTER //
// ./src/app/core/dialog/BemerkungDialogController.ts